import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Fotter } from "../../components";

const NewsDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);

  useEffect(() => {
    axios
      .get(`http://127.0.0.1:8000/api/news/${slug}/`)
      .then((response) => setNews(response.data))
      .catch((error) => {
        console.error("Xatolik:", error);
      });
  }, [slug]);

  // Agar `news` hali kelmagan bo‘lsa, loading holatini ko‘rsatamiz
  if (!news) {
    return (
      <div className="max-w-3xl mx-auto p-6 mt-36">
        <p className="text-center text-gray-500">Yuklanmoqda...</p>
      </div>
    );
  }

  return (
    <>
      <div className="max-w-3xl mx-auto p-6 mt-36">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition"
      >
        ⬅️ Ortga qaytish
      </button>

      {/* `news.photo` mavjudligini tekshirib ishlatamiz */}
      {news.photo && (
        <img
          src={`http://127.0.0.1:8000${news.photo}`}
          alt={news.title}
          className="w-full h-64 object-cover rounded-lg"
        />
      )}
      <h1 className="text-3xl font-bold mt-4">{news.title}</h1>
      <p className="text-gray-500">{news.date}</p>
      <p className="text-lg mt-4">{news.description}</p>

      {/* Link mavjud bo‘lsa ko‘rsatamiz */}
      {news.link && (
        <a
          href={news.link}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition inline-block"
        >
          🌍 Saytni ko‘rish
        </a>
      )}
    </div>
    <Fotter />
    </>
  );
};

export default NewsDetail;
